jQuery(document).ready(function() {
    console.log("test header");
      jQuery('.blue-candy').attr("aria-label","Blue");
      jQuery('.pink-candy').attr("aria-label","Pink");
      jQuery('.green-candy').attr("aria-label","Green");
      jQuery('.red-candy').attr("aria-label","Red");
      jQuery('.orange-candy').attr("aria-label","Orange");
      jQuery('.purple-candy').attr("aria-label","Purple");
      jQuery('.yellow-candy').attr("aria-label","Yellow");
      jQuery('.variant__countdown__bar__wrapper img').attr("alt","Purple, Violet, Magenta, Tints and shades, Font, Electric blue, Pattern, Carmine, Circle, Automotive tire");
      jQuery('.share__link--icon').attr("aria-label","share this product ");
      jQuery('#AAI-processing img').attr("alt","decorative image ");

	  jQuery('a[href="/pages/onward-checkout"] img').attr('alt', "Try Candy Risk Free. 90 days satisfaction gurantee powered by Onward");
	  jQuery('a[href="/pages/onward-checkout"]').attr('aria-label', "Onward Checkout");
	  jQuery('a[href="https://x.com/candywarehouse"]').attr('title', "Twitter X account");
	  jQuery('a[href="https://x.com/candywarehouse"] img').attr('alt', "");

      
	  jQuery('button[disabled="disabled"]').attr('title', " Discontinued ");

      jQuery('.subfooter__copyright a').attr("aria-label","Shopify website, opens in new tab");
      jQuery('#search-brands-input').attr("aria-label","search brands input field");

       
	  jQuery('a[href="/collections/chupa-chups"]').attr('aria-label', "Chupa chups");
	  jQuery('a[href="/collections/haribo"]').attr('aria-label', "haribo");
	  jQuery('a[href="/collections/pez"]').attr('aria-label', "pez");
	  jQuery('a[href="/collections/jolly-rancher"]').attr('aria-label', "jolly rancher");

	  jQuery('.header__logo.header__logo--image h2').attr('aria-level', "1");
	  jQuery('.standard__heading--adjust').attr('aria-level', "2");
	  jQuery('p.footer__title, .section-newsletter span').attr('aria-level', "2");
	  jQuery('p.footer__title, .tab-link span, .section-newsletter span').attr('role', "heading");
	  jQuery('.tab-link span').attr('aria-level', "3");

	  jQuery('.tabs--pill').attr('role', "tablist");
	  jQuery('.tabs--pill button').attr('role', "tab");
	  jQuery('a[href="/collections/christmas-candy"].link-over-image').attr("aria-label", "Christmas candy");

	  jQuery('.menu__item.grandparent.kids-4, .menu__item.grandparent.kids-0').attr("tabindex", "0");

	  jQuery('.search__predictive__actions input').attr("aria-label", "Search by color, brand and flavor");
	  jQuery('.search__predictive__actions input').attr("aria-autocomplete", "none");
	  jQuery('.search__predictive__actions input').attr("aria-haspopup", "listbox");

      
    

    


    


      
      



     });

     

     

     

  jQuery(document).ready(function(){
      setTimeout(function(){
         jQuery('#AAI-processing img').attr("alt","decorative image ");
         jQuery('.gowl-prev').attr("title","Previous");
         jQuery('.gowl-next').attr("title","Next");
         	    jQuery('.search__predictive__actions input').attr("aria-label", "Search by color, brand and flavor");
	            jQuery('.search__predictive__actions input').attr("aria-autocomplete", "none");
	            jQuery('.search__predictive__actions input').attr("aria-haspopup", "listbox");
	            jQuery('.slide-item.product-grid-slide.flickity-cell, .logo-grid-slide.flickity-cell, .gallery__item.flickity-cell').removeAttr("aria-hidden");

                

         //jQuery('[data-optimizer="Shopify"]').attr('style', 'opacity: 0.1 !important;');

         jQuery('.ga-product').each(function () {

            let productTitle = jQuery(this).find('.ga-product_title').text().trim();
            let productPrice = jQuery(this).find('.ga-product_price.money').text().trim();

            let ariaValue = productTitle + ' — Price: ' + productPrice;

            jQuery(this).find('input.selectedItem').attr('aria-label', ariaValue);
        });

       




       },
    3000);
  });

/*
  setTimeout(function () {
    jQuery('.gowl-item').each(function () {

        // Get product title text
        let title = jQuery(this).find('.ga-product_title').text().trim();

        // Find the FIRST <a> (the image link)
        let firstLink = jQuery(this).find('a').first();

        // Add aria-label using product title
        firstLink.attr('aria-label', title);
    });
}, 5000); // 3000 ms = 3 seconds


jQuery('a[target="_blank"]').each(function() {
    var linkText = jQuery(this).text().trim(); // Get the link text
    jQuery(this).attr('aria-label', linkText + ', opens in new tab');
});

*/

